function sortCustomDropdown() {
  const facetForm = document.querySelector('#FacetFiltersForm');
  const sortCont = document.querySelector('.collection__sort-wrapper');
  const sortLabel = document.querySelector('.collection__sort-label label');
  const sortLabelSpan = document.querySelector(
    '.collection__sort-label label span',
  );
  const sortSelect = document.querySelector('.collection__sort-select');
  const sortCustomSelectWrapper = document.querySelector(
    '.sort__custom-select-wrapper',
  );
  const sortCustomSelectOptions = document.querySelectorAll(
    '.sort__custom-select .option',
  );

  if (sortCont) {
    sortCont.addEventListener('click', (e) => {
      const sortCustomSelectOptions = document.querySelectorAll(
        '.sort__custom-select .option',
      );
      const sortOptions = document.querySelectorAll(
        '.collection__sort-select option',
      );

      // connect custom select with original select
      sortCustomSelectOptions.forEach((customOption) => {
        if (e.target == customOption) {
          // get position of clicked custom option
          let i = null;
          sortCustomSelectOptions.forEach((customOption, index) => {
            if (e.target == customOption) {
              i = index;
            }
          });

          // select custom option
          sortCustomSelectOptions.forEach((customOption, index) => {
            customOption.removeAttribute('selected');
          });
          e.target.setAttribute('selected', 'selected');

          // select original option
          sortOptions.forEach((option, index) => {
            option.removeAttribute('selected');
          });
          sortOptions[i].setAttribute('selected', 'selected');

          // submit form
          facetForm.submit();
        }
      });

      // toggle custom select dropdown
      const sortCustomSelectWrapper = document.querySelector(
        '.sort__custom-select-wrapper',
      );

      if (e.target == sortLabel || e.target == sortLabelSpan) {
        if (sortCustomSelectWrapper.classList.contains('active')) {
          sortCustomSelectWrapper.classList.remove('active');
        } else {
          if (window.matchMedia('(max-width: 768px)').matches) {
            const labelRect = sortLabel.getBoundingClientRect();
            sortCustomSelectWrapper.style.top = `${labelRect.bottom + 8}px`;
          } else {
            sortCustomSelectWrapper.style.top = '';
          }
          sortCustomSelectWrapper.classList.add('active');
        }
      }
    });
  }

  // close custom select when clicked outside
  if (sortCustomSelectOptions && sortCustomSelectWrapper) {
    window.addEventListener('click', (e) => {
      let close = true;
      if (
        e.target == sortSelect ||
        e.target == sortLabel ||
        e.target == sortLabelSpan
      ) {
        close = false;
      }
      sortCustomSelectOptions.forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        }
      });
      if (sortCustomSelectWrapper.classList.contains('active') && close) {
        sortCustomSelectWrapper.classList.remove('active');
      }
    });
  }

  // close custom select on scroll (mobile only): the dropdown uses
  // position: fixed there, so it doesn't track the sort button as the page
  // scrolls. Desktop keeps the sort bar sticky, so its dropdown stays
  // correctly anchored and doesn't need this.
  if (sortCustomSelectWrapper) {
    const closeSortOnMobileScroll = () => {
      if (
        window.matchMedia('(max-width: 768px)').matches &&
        sortCustomSelectWrapper.classList.contains('active')
      ) {
        sortCustomSelectWrapper.classList.remove('active');
      }
    };

    ['touchmove', 'wheel', 'scroll'].forEach((eventName) => {
      window.addEventListener(eventName, closeSortOnMobileScroll, {
        passive: true,
      });
    });
  }
}

export { sortCustomDropdown as default };
